import './Button.css';

export default function Button({
  children,
  variant = 'dark',
  href,
  onClick,
  type = 'button',
  className = '',
  ...props
}) {
  const cls = `btn btn--${variant}${className ? ` ${className}` : ''}`;

  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={cls} onClick={onClick} {...props}>
      {children}
    </button>
  );
}
